export function logout(){
    localStorage.clear();
    return true;
}